<template>
    <div class="confirm">

        <div class="confirm-content">
            <svg t="1727678109632" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2313" width="32" height="32">
                <path d="M511.302769 1022.605538a511.302769 511.302769 0 1 1 511.302769-511.302769 511.302769 511.302769 0 0 1-511.302769 511.302769z" fill="#00D264" p-id="2314"></path>
                <path d="M201.732183 453.200182a46.48207 46.48207 0 0 0 0 62.750794l189.646846 189.182024a64.145256 64.145256 0 0 0 90.175215 0l338.389469-337.459827a46.48207 46.48207 0 0 0-63.215615-63.215615l-320.261462 319.796641L264.947798 453.200182a46.48207 46.48207 0 0 0-63.215615 0z"
                      fill="#FFFFFF" p-id="2315"></path>
            </svg>
            <div class="confirm-title">您已注册！</div>
            <div class="confirm-text">You have registered</div>
            <div class="confirm-text">{{createTime}}</div>
        </div>

        <div class="confirm-btn">
            <div class="btn-primary" @click="onConfirm">确定</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'confirm',
    data() {
        return {
            createTime: '',
        };
    },
    created() {
        this.createTime = this.$route.query.time;
    },
    methods: {
        onConfirm() {
            this.$router.push({ path: '/' });
        },
    },
};
</script>

<style lang="scss" scoped>
.confirm {
    padding-top: 100px;
    .confirm-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        .icon {
            width: 120px;
            height: 120px;
        }
        .confirm-title {
            font-weight: bold;
            margin-top: 16px;
        }
        .confirm-text {
            color: #999;
            margin-top: 8px;
        }
    }
    .confirm-btn {
        display: flex;
        justify-content: center;
        .btn-primary {
            background: #00d264;
            color: #fff;
            padding: 10px 24px;
            margin-top: 16px;
            border-radius: 4px;
        }
    }
}
</style>